import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentUser: null,
  isAdmin: false,
  userCompany: null,
  loading: true, // Changed from false to true - prevents premature redirects on refresh
  isUserAuthenticated: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.currentUser = action.payload;
    },
    setIsAdmin: (state, action) => {
      state.isAdmin = action.payload;
    },
    setUserCompany: (state, action) => {
      state.userCompany = action.payload;
    },
    setIsUserAuthenticated: (state, action) => {
      state.isUserAuthenticated = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    logout: (state) => {
      state.currentUser = null;
      state.isAdmin = false;
      state.userCompany = null;
      state.isUserAuthenticated = false;
      state.loading = false;
    },
  },
});

export const {
  setUser,
  setIsAdmin,
  setUserCompany,
  setIsUserAuthenticated,
  setLoading,
  logout,
} = userSlice.actions;

export default userSlice.reducer;